import React, {useEffect, useMemo} from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Container, makeStyles, Paper, Typography, Grid } from "@material-ui/core";
import { Creators as ProductActions } from "../../../store/ducks/stock";
import Layout from "../../Layout/Layout";
import stockPageStyle from "./stockPageStyle";
import InputSearch from "../../InputSearch/InputSearch";
import StockItem from "../../StockItem/StockItem";
import { notifySuccess } from "../../../utils/js/helpers";
import { dynamicSearch } from "../../../api/services/productService";

const useStyles = makeStyles((theme) => stockPageStyle(theme));

const StockPage = ({ getProductList, stocks }) => {
  const classes = useStyles();
  const [listProducts, setListProducts] = React.useState([]);
  const [query, setQuery] = React.useState('')

  const computedProductList = useMemo(() => {
    return dynamicSearch(listProducts, query);
  },  [listProducts, query]);

  const { data, type } = stocks;

  useEffect(() => {
    const { type, error, loading } = stocks

    if (listProducts.length && !loading && type === "stock/UPDATE" && !error) {
      notifySuccess("Estoque Atualizado!")
    }
  }, [listProducts, stocks])

  useEffect(() => {
    if (!listProducts.length) {
      getProductList();
    }
  }, [getProductList, listProducts])

  useEffect(() => {
    if (type === "stock/SEARCH_ALL") {
      setListProducts(data);
    }
  }, [data, type]);

  return (
    <div className={classes.root}>
      <Layout title="Estoque">
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Paper className={classes.containerProducts}>
              <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                <Typography
                  component="h1"
                  variant="h5"
                  color="inherit"
                  noWrap
                  className={classes.title}
                >
                  Lista de estoques
                </Typography>
              </Grid>

              <InputSearch getProduct={setQuery} />

              <div>
                {computedProductList?.map((product) => (
                  <StockItem key={product.codigo} product={product} />
                ))}
              </div>
            </Paper>
          </Container>
        </main>
      </Layout>
    </div>
  );
};

const mapStateToProps = ({ stocks }) => ({ stocks });
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ProductActions, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(StockPage);
